import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh_cn from './lang/zh_cn'
import zh_tw from './lang/zh_tw'
import en from './lang/en'
Vue.use(VueI18n)

//ch_cn 中文简体  ch_tw 中文繁体
const messages = {
    'zh_cn': zh_cn,
    'zh_tw': zh_tw,
    'en':en,
}

let locale = 'zh_tw'
//先判断localstorage中是否有local，没有则获取浏览器语言标示，并设置localStorage
if(localStorage.locale){
  locale = localStorage.locale
}else{
  let lang = navigator.browserLanguage?navigator.browserLanguage:navigator.language
  if(lang.toLowerCase()=='zh-cn'){
    locale = 'zh_cn'
  }else{
    locale = 'zh_tw'
  }
  localStorage.locale = locale
}

export default new VueI18n({
    locale: locale, // 语言标识
    messages
})



// WEBPACK FOOTER //
// ./src/i18n/i18n.js